module.exports = new __parcel__URL__("watch-fork.43f496f1.png").toString();